import axios from 'axios';

import { TogglTimeEntry } from '../types/toggl-api';

const TOGGL_REPORTS_API_BASE_URL = 'https://api.track.toggl.com/reports/api/v3';

export function togglReportsApi(apiToken: string) {
  const togglProxyServerUrl = import.meta.env.VITE_TOGGL_PROXY_URL as
    | string
    | undefined;

  const axiosInstance = axios.create({
    baseURL: togglProxyServerUrl
      ? `${togglProxyServerUrl}/reports/api/v3/`
      : TOGGL_REPORTS_API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Basic ${window.btoa(apiToken + ':api_token')}`,
    },
  });

  return {
    async getTimeEntries(
      workspaceId: number,
      userId: number,
      start: string,
      stop: string,
      pageSize: number,
      offset: number
    ): Promise<TogglTimeEntry[]> {
      const { data } = await axiosInstance.post<TimeEntriesSearchResult[]>(
        `/workspace/${workspaceId}/search/time_entries`,
        {
          start_date: start,
          end_date: stop,
          page_size: pageSize,
          first_row_number: offset,
          user_ids: [userId],
        }
      );
      return mapToTimeEntries(workspaceId, data);
    },
  };
}

interface TimeEntriesSearchResult {
  at: string;
  billable: boolean;
  description: string;
  project_id: number;
  tags: string[];
  tag_ids: number[];
  task_id: number;
  time_entries: {
    id: number;
    start: string;
    stop: string;
    seconds: number;
  }[];
}

function mapToTimeEntries(
  workspaceId: number,
  data: TimeEntriesSearchResult[]
) {
  return data.map((v) => ({
    billable: v.billable,
    description: v.description,
    duration: v.time_entries[0].seconds,
    id: v.time_entries[0].id,
    start: v.time_entries[0].start,
    stop: v.time_entries[0].stop,
    project_id: v.project_id,
    task_id: v.task_id,
    tags: [],
    tag_ids: v.tag_ids,
    workspace_id: workspaceId,
    at: v.at,
  }));
}
